import React from 'react';
import { Text, Modal, ModalDivider, Icon } from '../../../common/components';
import { BuildingLogItem } from './BuildingLog';
import { formatDateTime } from '../../../common/utils/Date/Date';
import { getRegistryIcon, getRegistryTitle } from '../../utils/registryHelpers';
import { parseBuildingLogData, filterProfilesByOwnerChange } from '../../utils/buildingLog/BuildingLogDataParser';
import { renderDiffItems, renderUnitLinks, renderProfileLinks } from '../../utils/buildingLog/BuildingLogRenderer';

interface BuildingLogModalProps {
  log: BuildingLogItem;
  isShown: boolean;
  onHide: () => void;
}

export const BuildingLogModal: React.FC<BuildingLogModalProps> = ({ log, isShown, onHide }) => {
  // Parsování dat podle nové struktury
  const diffItems = parseBuildingLogData(log.data, log.profiles);
  // U změn vlastníka jednotky zobrazíme jen dotčené profily, ne všechny spoluvlastníky
  const relevantProfiles = filterProfilesByOwnerChange(log.profiles, diffItems);

  return (
    <Modal isShown={isShown} onHide={onHide} size='large' className={`BuildingLogModal BuildingLogModal--${log.messageType.toLowerCase()}`}>
      <div className="BuildingLogModal__header mb-1">
        <Icon name={getRegistryIcon(log.typeGroup)} color="Neutral600" className='BuildingLogModal__header__icon' />
        <Text size="body-medium">{getRegistryTitle(log.typeGroup)}</Text>
      </div>

      <Text size="h3">{log.message}</Text>
      <Text className='' size="body-small" weight='400' color='Neutral600'>Změna zaznamenána: {formatDateTime(log.recordedAt)}</Text>
      
      {((log.units?.length || 0) > 0 || (relevantProfiles?.length || 0) > 0) && (
        <div className="BuildingLogModal__header mb-1 mt-1">
          <Text size="body-medium">
            Tato změna se týká {' '}
            {log.units?.length && (
              <>
                jednotek: {renderUnitLinks(log.units)}
                {relevantProfiles?.length ? ' a ' : ''}
              </>
            )}
            {relevantProfiles?.length ? (
              <>vlastníků: {renderProfileLinks(relevantProfiles)}</>
            ) : null}
          </Text>
        </div>
      )}

      <ModalDivider />
      <div>
        {renderDiffItems(diffItems)}
      </div>
    </Modal>
  );
};